import { useEffect, useState } from 'react';

import { getTrelloBoards, TrelloBoard } from '../api/integration';

// Module-level cache — several chat components (session picker, sidebar, chat view) need the same
// board list; avoids a duplicate GET /api/integrations/trello/boards per mount.
let cache: TrelloBoard[] | null = null;
let inflight: Promise<TrelloBoard[]> | null = null;

export function useTrelloBoards() {
  const [boards, setBoards] = useState<TrelloBoard[]>(cache ?? []);
  const [isLoading, setIsLoading] = useState(!cache);

  useEffect(() => {
    if (cache) {
      setBoards(cache);
      setIsLoading(false);
      return;
    }

    if (!inflight) {
      inflight = getTrelloBoards()
        .then((result) => {
          cache = result;
          return result;
        })
        .finally(() => {
          inflight = null;
        });
    }

    let cancelled = false;
    setIsLoading(true);
    inflight
      .then((result) => {
        if (!cancelled) setBoards(result);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { boards, isLoading };
}
